import Quill from 'quill';

const Icons = Quill.import('ui/icons');
Icons.mathlive = Icons.formula;

export default Icons;
